import React, { useState, useEffect } from "react";
import jsonConfig from "../../../config.json";

const BANNER_HEIGHT = 48;

// Checked once, on load. It used to poll every 30s, which meant the banner
// reflected whichever API node Kong happened to pick that tick -- api03 could
// say read-only while api01 and api02 said fine, and the banner flickered on
// and off for a database that was healthy. The check is now a real write on
// the node serving you, so a save that would fail is what turns this red.
const SystemStatusBanner = () => {
  const [readOnly, setReadOnly] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    let mounted = true;

    const checkStatus = async () => {
      try {
        const res = await fetch(`${jsonConfig.urlBase}/system/status`);
        const data = await res.json();
        if (mounted && data?.result) {
          setReadOnly(!!data.result.read_only_mode);
          setMessage(data.result.message || "System is in emergency read-only mode. Changes cannot be saved.");
        }
      } catch {
        // Don't show banner on fetch error -- could be the API itself being down,
        // which is a different failure mode
      }
    };

    checkStatus();
    return () => { mounted = false; };
  }, []);

  if (!readOnly) return null;

  return (
    <>
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: BANNER_HEIGHT,
        backgroundColor: "#dc3545",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: 14,
        zIndex: 9999,
        letterSpacing: "0.3px",
      }}>
        ⚠️ {message}
      </div>
      <div style={{ height: BANNER_HEIGHT }} />
    </>
  );
};

export default SystemStatusBanner;
